export default {
  currentRole: JSON.parse(window.localStorage.getItem('role')) || null,
  activeUser: JSON.parse(window.localStorage.getItem('user')) || null,
}
